// Accueil GS Gestion — squelette scaffold : salutation + tuiles des modules a venir
// (equipes, rencontres, pulse, finance, remuneration, publications — Frags 3+ du plan
// MASTER-INTEGRATION-GESTION). Tuiles DESACTIVEES (non cliquables) : contrat visuel DS
// (card blanche rounded-xl shadow-sm, icone dans une pastille colombe bg-*-50 — jamais
// de card entierement coloree). Composants @gs/ui existants seulement (piege R1 :
// aucun composant nouveau — grep barrel + COMPONENT_CATALOG fait, rien a creer pour
// une grille de tuiles statiques).
import { PageHeader } from '@gs/ui';
import {
  Users, CalendarDays, HeartPulse, Wallet, BadgeDollarSign, Megaphone,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { useAuth } from '@gs/auth';
import { useTranslation } from '../i18n';

interface ModuleTile {
  key: string;
  icon: LucideIcon;
  iconClasses: string; // pastille : bg-*-50 + text-*-600 (tokens DS, dark variant)
}

// Ordre = ordre des frags ecrans recommandes par l'audit 360 §B4 (3..8).
const MODULE_TILES: ModuleTile[] = [
  { key: 'teams', icon: Users, iconClasses: 'bg-blue-50 text-blue-600 dark:bg-blue-950 dark:text-blue-400' },
  { key: 'meetings', icon: CalendarDays, iconClasses: 'bg-violet-50 text-violet-600 dark:bg-violet-950 dark:text-violet-400' },
  { key: 'pulse', icon: HeartPulse, iconClasses: 'bg-brand-50 text-brand-600 dark:bg-brand-500/10 dark:text-brand-300' },
  { key: 'finance', icon: Wallet, iconClasses: 'bg-green-50 text-green-600 dark:bg-green-950 dark:text-green-400' },
  { key: 'compensation', icon: BadgeDollarSign, iconClasses: 'bg-red-50 text-red-600 dark:bg-red-950 dark:text-red-400' },
  { key: 'publications', icon: Megaphone, iconClasses: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400' },
];

export default function HomePage() {
  const { user } = useAuth();
  const { t } = useTranslation();
  return (
    <div className="space-y-5">
      <PageHeader
        title={t('gest:home.greeting', { name: user?.name ?? '' })}
        description={t('gest:home.subtitle')}
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {MODULE_TILES.map(({ key, icon: Icon, iconClasses }) => (
          <div
            key={key}
            aria-disabled="true"
            className="rounded-xl border border-slate-200 bg-white p-5 opacity-70 shadow-sm dark:border-slate-700 dark:bg-slate-800"
          >
            <div className="flex items-start justify-between">
              <div className={`flex h-10 w-10 items-center justify-center rounded-full ${iconClasses}`}>
                <Icon size={20} aria-hidden="true" />
              </div>
              <span className="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-medium text-slate-500 dark:bg-slate-700 dark:text-slate-400">
                {t('gest:home.comingSoon')}
              </span>
            </div>
            <h3 className="mt-3 text-sm font-semibold text-slate-900 dark:text-slate-100">
              {t(`gest:modules.${key}.title`)}
            </h3>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              {t(`gest:modules.${key}.description`)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
